module.exports = __webpack_public_path__ + "img/like.eb302768.svg";